/* eslint-disable no-inner-declarations */
require("@babel/polyfill");
const Glide = require('@glidejs/glide');

// MODAL
var MicroModal = require('micromodal');


// REMOVE 'NO-JS' CLASS FROM HTML --------------------
var root = document.documentElement;
root.classList.remove("no-js");
root.classList.add("js");

// SMOOTH SCROLL TO CONTACT INFO AT BOTTOM OF SITE ---------------
window.__forceSmoothScrollPolyfill__ = true;
require('smoothscroll-polyfill').polyfill();
for (var item of document.querySelectorAll(".nav--primary a[href*='#']"))
{
	item.addEventListener('click', function(e) {
		e.preventDefault();
		smoothScrollTo(e.target.hash)
	}, false);
}

function smoothScrollTo(id)
{
	document.querySelector(id).scrollIntoView({
		behavior: "smooth"
	});
}

// PRIMARY NAV -------------------------
const Nav = require('bluegg-nav');

var mainNav = new Nav({
	nav: '.nav--primary',
	trigger: '#primary-nav-trigger'
});

// ELEMENTARY --------------------------

const elementary = require('./vendor/elementary.js');

window.addEventListener( 'load', elementary, false );
window.addEventListener( 'resize', elementary, false );

// SCROLL STUFF -------------------------

var scrollClass = 'js-entered-view';
const scrollama = require('scrollama');

const scroller = scrollama();

scroller
	.setup({
		step: '[data-step]',
		offset: 0.9
	})
	.onStepEnter(handleStepEnter);

function handleStepEnter(e)
{
	e.element.classList.add(scrollClass);
}

setTimeout(function() {
	(function() {
		for (var item of document.querySelectorAll('.hero')) {
			item.classList.add(scrollClass);
		}
	})();
}, 50);

// FORM VALIDATION ---------------------

const $       = require('jquery');
const Parsley = require('parsleyjs');

$('.form--contact').parsley({
	errorClass: 'form-group--error',
	errorsWrapper: '<ul class="errors"></ul>',
	errorTemplate: '<li class="errors__item"></li>',
	classHandler: function(ParsleyField) {
		var el      = ParsleyField.$element;
		var groupEl = el.parent().parent()

		if (el.hasClass('chkbox__field'))
		{
			groupEl = el.parent().parent().parent();
		}

		return groupEl;
	},
	errorsContainer: function(ParsleyField) {
		var el      = ParsleyField.$element;
		var groupEl = el.parent().parent()

		if (el.hasClass('chkbox__field'))
		{
			groupEl = el.parent().parent().parent();
		}

		return groupEl.find('.form-group__errors');
	}
});


let glideEl = document.querySelector('.glide');

if (glideEl) {
	new Glide('.glide').mount();
}

const teamExpand = document.querySelectorAll('.js-team-expand');

[].forEach.call(teamExpand, (btn) => {
	btn.innerHTML = btn.dataset.closeText;
	btn.addEventListener('click', (e) => {
		e.preventDefault();
		const isExpanded = e.target.getAttribute('aria-expanded') === 'true';
		e.target.setAttribute('aria-expanded', !isExpanded);
		e.target.innerHTML = isExpanded ? btn.dataset.closeText : btn.dataset.openText; 
	});
});


// Calculator 
if	(document.querySelector("#calculator-form")) {
		
	const calculator = document.querySelector("#calculator-form");
	const planData = JSON.parse(document.querySelector("#plan-data").innerHTML).plans;
	const field = calculator.querySelector('#calculator');
	const calcBtn = calculator.querySelector('button[type="submit"]');
	// const tableRow = `<tr><td>Year ${year}</td><td>£${amount}</td><td>£${interest}</td><td>${rate}%</td></tr>`;
	let investmentVal = field.value;

	function numberWithCommas(num) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	function calculateMonthly(val, plan) {

		const valNum = parseInt(val);

		const yearlyInterest = plan.years.map((rate) => {
			return valNum*(rate/100);
		});

		let breakdown = plan.years.map((rate, i) => {
			const interest = valNum*(rate/100);
			return {
				year: i + 1,
				amount: numberWithCommas(valNum),
				interest: numberWithCommas(interest.toFixed(2)),
				rate: rate
			};
		});

		const totalInt = yearlyInterest.reduce((a, b) => a + b, 0);
		return {
			totalMonthly: (totalInt/plan.years.length).toFixed(2),
			total: totalInt + valNum,
			totalInterest: totalInt.toFixed(2),
			interest: Math.round(totalInt / parseInt(investmentVal)*100),
			breakdown: breakdown
		};
	} 

	function calculateCompound(val, plan) {

		const valNum = parseInt(val);
		let compoundVal = valNum;
		let breakdownCompound = valNum;
		
		let totalInt = 0;

		plan.years.forEach((rate) => {
			let interest = compoundVal*(rate/100);
			totalInt = totalInt + interest;
			
			return compoundVal = compoundVal + interest;
		});

		let breakdown = plan.years.map((rate, i) => {
			let interest = breakdownCompound*(rate/100);
			let amount = breakdownCompound;
			breakdownCompound = amount + interest;
			return {
				year: i + 1,
				amount: numberWithCommas(amount),
				interest: numberWithCommas(interest.toFixed(2)),
				rate: rate
			};
		});

		return {
			total: compoundVal.toFixed(2),
			totalInterest: totalInt.toFixed(2),
			interest: Math.round(totalInt/parseInt(investmentVal)*100),
			breakdown: breakdown
		};

	}

	function runCalcs(val, plans) {
		plans.forEach((plan, i) => {
			
			let monthlyVal = null;
			let compVal = null;

			if (plan.monthly) {
				monthlyVal = calculateMonthly(val, plan);
			} else {
				compVal = calculateCompound(val, plan);
			}

			return updateUI(monthlyVal || compVal, i);
		});


	}

	function checkNaN(num) {
		return num !== num;
	}

	function updateUI(valObj, index) {
		const resultEl = document.querySelector(`#result-${index}`);
		const valEl = resultEl.querySelector('.js-result-value');
		const intEl = resultEl.querySelector('.js-result-rate');
		const tableBodyEl = document.querySelector(`#table-${index}`);
		const breakdownTotalEl = document.querySelector(`#total-return-${index}`);

		if (checkNaN(valObj.total) || checkNaN(valObj.interest)) {
		
			valEl.innerHTML = 'Please enter a number';
			intEl.innerHTML = '';
			return;

		}

		let breakdown = valObj.breakdown.map((data) => {
			return `<tr><td>Year ${data.year}</td><td>£${data.amount}</td><td>£${data.interest}</td><td>${data.rate}%</td></tr>`;
		});

		valEl.innerHTML = `£${numberWithCommas(valObj.totalInterest )}`;
		intEl.innerHTML = `${numberWithCommas(valObj.interest)}%`;
		breakdownTotalEl.innerHTML = `£${numberWithCommas(valObj.totalInterest)}`;
		tableBodyEl.innerHTML = breakdown.join('');
		
	}

	calcBtn.addEventListener('click', (e) => {
		e.preventDefault();
		investmentVal = field.value;

		if (checkNaN(parseInt(investmentVal))) {
			calculator.classList.add('is-error');
			return;
		}  

		if (parseInt(investmentVal) < parseInt(field.getAttribute('min'))) {
			calculator.classList.add('is-error');
			return;
		}

		calculator.classList.remove('is-error');
		return runCalcs(investmentVal, planData);

	});

	runCalcs(investmentVal, planData);

	var scrollPos;

	function onShow(modal) {
		console.log('SHOW');
			document.documentElement.classList.add('modal-open')
	}
	function onClose(modal) {
		console.log('CLOSE');
			document.documentElement.classList.remove('modal-open');
			document.querySelector('#tandc').removeAttribute('required');
	}

	MicroModal.init({
		onShow: onShow, 
		onClose: onClose
	});

$('#calculator-pre-form').parsley({
	errorClass: 'form-group--error',
	errorsWrapper: '<ul class="errors"></ul>',
	errorTemplate: '<li class="errors__item"></li>',
	classHandler: function(ParsleyField) {
		var el      = ParsleyField.$element;
		var groupEl = el.parent().parent()

		if (el.hasClass('chkbox__field'))
		{
			groupEl = el.parent().parent().parent();
		}

		return groupEl;
	},
	errorsContainer: function(ParsleyField) {
		var el      = ParsleyField.$element;
		var groupEl = el.parent().parent()

		if (el.hasClass('chkbox__field'))
		{
			groupEl = el.parent().parent().parent();
		}

		return groupEl.find('.form-group__errors');
	}
});

$('#pre-form-btn').on('click', function(e) {
	e.preventDefault();
	if( $('#calculator-pre-form').parsley().isValid()) {
		
		MicroModal.show('modal-1', {
			onShow: onShow,
			onClose: onClose
		});
		$('#modal-1 #tandc').attr('required', 'true');
		field.value = $('.js-investment-val').val()
		

		// SUBMIT DETAILS TO MAILCHIMP HERE

	} else {
		$('#calculator-pre-form').parsley().validate()
	}
})

$('#pre-form-submit').on('click', function(e) {
	e.preventDefault();

	var $form = $('#calculator-pre-form');

	if( $form.parsley().isValid()) {
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action') + '&c=?',
        data: $form.serialize(),
        cache       : false,
        dataType    : 'jsonp',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
            if (data.result != "success") {
								// Something went wrong, do something to notify the user. maybe alert(data.msg);
								console.error(data)
            } 
						// It worked, carry on...
						mcSuccess();

        }
    });
	} else {
		$('#calculator-pre-form').parsley().validate()
	}
})

function mcSuccess() {
	MicroModal.close('modal-1', {
		onShow: onShow,
		onClose: onClose
	});
	
	// NEED TO COPY VALUE ACROSS, CLICK CALCULATOR SUBMIT

	$('#investment-calculator-1').addClass('hidden');
	calcBtn.click();
	$('#investment-calculator-2').removeClass('hidden');
}

}


if (document.querySelectorAll('#mapid').length) {
	var mql = window.matchMedia('(max-width: 720px)');
	let zoomLevel = mql.matches ? 9 : 10;
	// MAP
	var L = require('leaflet');
	var accessToken = 'pk.eyJ1IjoiYmx1ZWdnZGV2IiwiYSI6ImNrMjF2dDc1NDFlYnQzZXVnZ2cweTM0bTMifQ.bWOJx2ZTRIVtGvUOuXY_vg'
	var mymap = L.map('mapid').setView([51.5265, -3.1599], zoomLevel);
	L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmx1ZWdnZGV2IiwiYSI6ImNrMjF2dDc1NDFlYnQzZXVnZ2cweTM0bTMifQ.bWOJx2ZTRIVtGvUOuXY_vg', {
		attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	}).addTo(mymap);
	const properties = JSON.parse(document.querySelector("#properties").innerHTML).properties;

	var piIcon = L.icon({
		iconUrl: '/images/pi-pin.png',
		iconSize:     [29, 41], // size of the icon
		shadowSize:   [0, 0], // size of the shadow
		iconAnchor:   [15, 41], // point of the icon which will correspond to marker's location
		shadowAnchor: [0, 0],  // the same for the shadow
		popupAnchor:  [0, -42] // point from which the popup should open relative to the iconAnchor
	});

	function screenTest(e) {
		if (e.matches) {
			mymap.setZoom(9);
		} else {
			mymap.setZoom(10);
		}
	}
	
	properties.forEach((property) => {
		return L.marker([property.latitude, property.longitude], {icon: piIcon}).addTo(mymap).bindPopup(`<b class="heading heading--h4">${property.name}</b>`);
	});
	
	mql.addListener(screenTest);
}

